module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Right 3-979430e7d32788e94f2732e5b1c91a45.svg";